setUpstreamContext